export enum institutionTypes {
  SCHOOL = 'School',
  DAYCARE = 'Daycare',
  INSTITUTION = 'Institution',
  MUNICIPALITY = 'Municipality',
  CENTRAL = 'Central',
  MUNICIPALITY_DK = 'Kommune',
}
